<template>
  <div>
    <div style="width: 100%; height: 400px" ref="editor"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ace from 'ace-builds/src-min-noconflict/ace'
//import 'ace-builds/webpack-resolver'
import 'ace-builds/src-min-noconflict/mode-json'
//import 'ace-builds/src-min-noconflict/worker-json'
import 'ace-builds/src-min-noconflict/theme-chrome'
import 'ace-builds/src-min-noconflict/theme-dracula'

export default {
  name: 'JsonEditorAce',
  props: ['value'],
  data() {
    return {
      editor: undefined
    }
  },
  computed: {
    aceTheme: function() {
      if (this.isLightTheme) {
        return 'ace/theme/chrome'
      } else {
        return 'ace/theme/dracula'
      }
    },
    ...mapState(['isLightTheme'])
  },
  mounted: function() {
    ace.config.setModuleUrl(
      'ace/mode/json_worker',
      require('file-loader!ace-builds/src-noconflict/worker-json.js')
    )
    this.editor = ace.edit(this.$refs.editor, {
      mode: 'ace/mode/json',
      theme: this.aceTheme,
      useSoftTabs: true,
      //useWorker: false,
      minLines: 25
    })
    this.editor.setValue(this.value)
    this.editor.selection.clearSelection()
    this.editor.session.on(
      'change',
      function() {
        this.$emit('inputText', this.editor.getValue())
      }.bind(this)
    )
  },
  watch: {
    isLightTheme: function() {
      this.editor.setTheme(this.aceTheme)
    },
    value: function(nv, ov) {
      if (nv !== ov) {
        let position = this.editor.selection.getCursor()
        this.editor.setValue(nv)
        this.editor.selection.moveCursorToPosition(position)
        this.editor.selection.clearSelection()
      }
    }
  }
}
</script>
